import { Component, OnInit, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ApiService } from '../../../../core/services/api.service';
import { IndividualToasterComponent } from '../../../../shared/components/loader/loader.component';

import { AuditLogPanelComponent } from '../../../../shared/components/audit-log-panel/audit-log-panel.component';
import { AuditEntityType } from '../../../../core/models/audit-log.model';

@Component({
  selector: 'app-manage-roles',
  standalone: true,
  imports: [CommonModule, RouterModule, IndividualToasterComponent, AuditLogPanelComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './manage-roles.component.html',
})
export class ManageRolesComponent implements OnInit {
  private apiService = inject(ApiService);
  roles = signal<any[]>([]);
  isLoading = signal<boolean>(false);
  auditEntityTypes = [AuditEntityType.ROUTE_PERMISSION];

  ngOnInit(): void {
    this.fetchRoles();
  }

  fetchRoles(): void {
    this.isLoading.set(true);
    this.apiService
      .get(
        '/roles/list',
        { status: 'ACTIVE' },
        {
          showLoader: false,
          showErrorToaster: true,
        },
      )
      .subscribe({
        next: (response: any) => {
          this.isLoading.set(false);

          // Resilient response mapping
          if (Array.isArray(response)) {
            this.roles.set(response);
          } else if (response?.roles && Array.isArray(response.roles)) {
            this.roles.set(response.roles);
          } else if (response?.data && Array.isArray(response.data)) {
            this.roles.set(response.data);
          } else {
            this.roles.set([]);
          }
        },
        error: (error) => {
          this.isLoading.set(false);
          console.error('Error fetching roles:', error);
        },
      });
  }
}
